import React, { useState } from 'react';
import { Button } from './ui/button';
import ContactFormModal from './ContactFormModal';

const WhyChooseSection = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);

  return (
    <>
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Left content */}
            <div className="space-y-6">
              <h2 className="text-4xl md:text-5xl font-bold leading-tight">
                <span className="text-gray-900">AES-256 Level Encryption Standard</span>
              </h2>
              
              <h3 className="text-3xl md:text-4xl font-bold text-blue-800">
                Because everything in your inbox reflects your personal and professional security.
              </h3>

              <div className="space-y-4 text-gray-600 text-lg">
                <p>
                  Major providers like Gmail, Outlook, and Yahoo analyze email data and use it for advertising-based profiling and monetization.
                </p>

                <p>
                  Encryptofy Mail uses military-grade end-to-end encryption with a zero-knowledge system, ensuring only you can access your data. Even our infrastructure cannot decrypt emails or attachments.
                </p>
              </div>

              <div className="pt-4">
                <Button 
                  onClick={() => setIsContactOpen(true)}
                  className="bg-teal-500 hover:bg-teal-600 text-white font-semibold px-8 py-6 text-lg rounded-md transition-all duration-300 hover:scale-105 hover:shadow-lg"
                >
                  Protect Your Inbox Today
                </Button>
              </div>
            </div>

            {/* Right image */}
            <div className="relative">
              <div className="relative overflow-hidden rounded-2xl shadow-2xl group">
                <img
                  src="/assets/right-side-img.jpg"
                  alt="Digital Security Network"
                  className="w-full h-auto transform transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
              
              {/* Decorative elements */}
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-teal-500 rounded-full filter blur-2xl opacity-20 animate-pulse" style={{ animationDuration: '3s' }}></div>
              <div className="absolute -top-6 -left-6 w-24 h-24 bg-blue-500 rounded-full filter blur-2xl opacity-20 animate-pulse" style={{ animationDuration: '4s' }}></div>
            </div>
          </div>
        </div>
      </section>

      <ContactFormModal 
        isOpen={isContactOpen} 
        onClose={() => setIsContactOpen(false)}
        title="Secure Your Email Now"
      />
    </>
  );
};

export default WhyChooseSection;